<template>
    <div>
      <div class="tabs is-centered is-toggle">
        <ul>
          <li :class="{'is-active': tabActive === 'info1'}" @click="tabActive = 'info1'">
            <a>
              <span class="icon is-small"><font-awesome-icon icon="file-lines" /></span>
              <span>1. Generali</span>
            </a>
          </li>
          <li :class="{'is-active': tabActive === 'info2'}" @click="tabActive = 'info2'">
            <a>
              <span class="icon is-small"><font-awesome-icon icon="file-lines" /></span>
              <span>2. Trattamento acqua</span>
            </a>
          </li>
          <li :class="{'is-active': tabActive === 'info3'}" @click="tabActive = 'info3'">
            <a>
              <span class="icon is-small"><font-awesome-icon icon="file-lines" /></span>
              <span>3. Terzo responsabile</span>
            </a>
          </li>
          <li :class="{'is-active': tabActive === 'info4'}" @click="tabActive = 'info4'">
            <a>
              <span class="icon is-small"><font-awesome-icon icon="file-lines" /></span>
              <span>4. Generatori</span>
            </a>
          </li>
          <li :class="{'is-active': tabActive === 'info5'}" @click="tabActive = 'info5'">
            <a>
              <span class="icon is-small"><font-awesome-icon icon="file-lines" /></span>
              <span>5. Sistemi di regolazione e contabilizzazione</span>
            </a>
          </li>
        </ul>
      </div>

      <div class="tabs is-centered is-toggle">
        <ul>
          <li :class="{'is-active': tabActive === 'info6'}" @click="tabActive = 'info6'">
            <a>
              <span class="icon is-small"><font-awesome-icon icon="file-lines" /></span>
              <span>6. Sistemi di distribuzione</span>
            </a>
          </li>
          <li :class="{'is-active': tabActive === 'info7'}" @click="tabActive = 'info7'">
            <a>
              <span class="icon is-small"><font-awesome-icon icon="file-lines" /></span>
              <span>7. Sistema di emissione</span>
            </a>
          </li>
          <li :class="{'is-active': tabActive === 'info8'}" @click="tabActive = 'info8'">
            <a>
              <span class="icon is-small"><font-awesome-icon icon="file-lines" /></span>
              <span>8. Sistema di accumulo</span>
            </a>
          </li>
          <li :class="{'is-active': tabActive === 'info9'}" @click="tabActive = 'info9'">
            <a>
              <span class="icon is-small"><font-awesome-icon icon="file-lines" /></span>
              <span>9. Altri componenti dell'impianto</span>
            </a>
          </li>
          <li :class="{'is-active': tabActive === 'info10'}" @click="tabActive = 'info10'">
            <a>
              <span class="icon is-small"><font-awesome-icon icon="file-lines" /></span>
              <span>10. Impianto di ventilazione meccanica controllata</span>
            </a>
          </li>
        </ul>
      </div>
  
      <transition name="fade" mode="out-in">
        <div v-show="tabActive === 'info1'">
          <General :implant="implant" @update:implant="$emit('update:implant', $event)" :clients="clients" @openNewOccupant="$emit('openNewOccupant')" @openNewClient="$emit('openNewClient')" @editPlace="$emit('editPlace')" @openNewPlace="$emit('openNewPlace')" @openAppointment="$emit('openAppointment', $event)" />
        </div>
      </transition>

      <transition name="fade" mode="out-in">
        <div v-show="tabActive === 'info2'">
          <Water :implant="implant" @update:implant="$emit('update:implant', $event)" />
        </div>
      </transition>

      <transition name="fade" mode="out-in">
        <div v-show="tabActive === 'info3'">
          <Resp :implant="implant" @update:implant="$emit('update:implant', $event)" :clients="clients" />
        </div>
      </transition>
  
      <transition name="fade" mode="out-in">
        <div v-show="tabActive === 'info4'">
          <Generator :implant="implant" @update:implant="$emit('update:implant', $event)" @transfer="transfer" />
        </div>
      </transition>
  
      <transition name="fade" mode="out-in">
        <div v-show="tabActive === 'info5'">
          <Regulation :implant="implant" @update:implant="$emit('update:implant', $event)" />
        </div>
      </transition>
  
      <transition name="fade" mode="out-in">
        <div v-show="tabActive === 'info6'">
          <Distribution :implant="implant" @update:implant="$emit('update:implant', $event)" />
        </div>
      </transition>
  
      <transition name="fade" mode="out-in">
        <div v-show="tabActive === 'info7'">
          <Emission :implant="implant" @update:implant="$emit('update:implant', $event)" />
        </div>
      </transition>
  
      <transition name="fade" mode="out-in">
        <div v-show="tabActive === 'info8'">
          <Accumulation :implant="implant" @update:implant="$emit('update:implant', $event)" />
        </div>
      </transition>
  
      <transition name="fade" mode="out-in">
        <div v-show="tabActive === 'info9'">
          <Other :implant="implant" @update:implant="$emit('update:implant', $event)" />
        </div>
      </transition>
  
      <transition name="fade" mode="out-in">
        <div v-show="tabActive === 'info10'">
          <Ventilation :implant="implant" @update:implant="$emit('update:implant', $event)" />
        </div>
      </transition>

      <div class="is-full mt-4 mb-4">
        <div class="field is-grouped is-grouped-centered buttons">
          <button @click="goBack()" class="button is-light" type="button"><font-awesome-icon icon="times" />Chiudi</button>
          <button v-if="$store.getters.amAdmin" class="button is-primary" :class="[{'is-loading': disabledSave}]" :disabled="disabledSave" @click="implant._id ? updateImplant() : saveImplant()"><font-awesome-icon icon="save" />Salva</button>
        </div>
      </div>
  
      <!--<AppointmentCalendar :deadline="deadline" :open="openModalAppointment" @close="this.openModalAppointment = false" @saved="$router.push('/appuntamenti/' + $event)" />-->
      <Transfer v-if="openModalTransfer" @close="openModalTransfer = false" @save="saveTransfer" />
    </div>
  </template>
  
<script>
import utils from '../utils'

import General from './implant-form/1-general'
import Water from './implant-form/2-water'
import Resp from './implant-form/3-resp'
import Generator from './implant-form/4-generator'
import Regulation from './implant-form/5-regulation'
import Distribution from './implant-form/6-distribution'
import Emission from './implant-form/7-emission'
import Accumulation from './implant-form/8-accumulation'
import Other from './implant-form/9-other'
import Ventilation from './implant-form/10-ventilation'

export default {
  components: {
    General,
    Water,
    Resp,
    Generator,
    Regulation,
    Distribution,
    Emission,
    Accumulation,
    Other,
    Ventilation
  },

  props: {
    implant: Object,
    clients: Array
  },
  emits: ['update:implant', 'openNewOccupant', 'openNewClient', 'editPlace', 'openNewPlace', 'openAppointment'],

  data() {
      return {
        places: [],

        tabActive: 'info1',

        waitRecord: true,
        waitPlaces: false,

        disabledSave: false,

        openModalAppointment: false,
        deadline: {},

        init: {
          name: false,
          subname: false
        },

        openNewModal: false,
        disabledClientSave: false,
        newClient: {
          contacts: [{}],
          sameForPlace: false
        },

        newType: false,

        editPlaceForm: {},
        editPlaceType: false,

        openModalTransfer: false,

        transferElement: null,
        transferType: null
      }
  },

  methods: {
    checkRequired() {
      if (!this.implant.client) {
        alert('Proprietario obbligatorio!')
        return false
      }
      if (!this.implant.occupant) {
        alert('Occupante obbligatorio!')
        return false
      }
      if (!this.implant.place_occupant) {
        alert('Luogo obbligatorio!')
        return false
      }

      return true
    },

    saveImplant() {
      if (!this.checkRequired()) {
        return false
      }

      const self = this
      this.disabledSave = true

      this.$http.post('/implant', this.implant)
      .then(function (response) {
        utils.deleteDraft(self, self.implant._timestamp, 'implant').then(() => {
          self.$router.options.history.state.position ? self.$router.back() : self.$router.push('/impianti')
        })
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        self.disabledSave = false
      })
    },

    updateImplant() {
      const self = this
      this.disabledSave = true

      this.$http.put('/implant/' + this.implant._id, this.implant)
      .then(function (response) {
        self.$router.options.history.state.position ? self.$router.back() : self.$router.push('/impianti')
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        self.disabledSave = false
      })
    },

    goBack() {
      this.$store.commit('setForm', {name: 'implant', value: false})
      this.$router.back()
    },

    transfer(element, type) {
      this.openModalTransfer = true

      this.transferElement = element
      this.transferType = type
    },

    saveTransfer(destination) {
      //this.selectedElement.archived = true
      //this.selectedElement._showall = false
      //this.selectedElement.transfer_implant = ''

      const self = this
      //self.loadingSave = true

      this.$http.post('/implant/' + this.implant._id + '/' + this.transferType + '/' + this.transferElement._id + '/transfer', { id_implant_destination: destination })
      .then(function (response) {
        if (response && response.data) {
          /*self.implants = response.data.records
          if (self.implants?.length === 1) {
            self.transferDestination.implant = self.implants[0]
            self.changeImplant(self.implants[0])
          }*/
         self.openModalTransfer = false
        }
        //self.loadingSave = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
      })
    }
  },

  mounted() {
    /*const self = this

    const id = this.$route.params.id

    if (id) {
      this.$http.get('/implant/' + id)
      .then(function (response) {
        self.implant = response.data

        self.init.subname = (self.implant.brand + ' ' + self.implant.model).trim()

        if (self.implant.client) {
          if (self.implant.client.business_name) {
            self.init.name = self.implant.client.business_name
          } else {
            self.init.name = self.$fullname(self.implant.client)
          }
        }
        self.waitRecord = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
      })
    } else {
      self.waitRecord = false

      if (this.$store.getters.getForm('implant')) {
        self.implant = this.$store.getters.getForm('implant')
      }
    }*/
  }
}
</script>